import React from 'react';
import { ThemeProvider } from 'styled-components';

import { DefaultLoader } from '@savgroup-front-common/core/atoms/loader/DefaultLoader';
import defaultTheme from '@savgroup-front-common/core/theme/defaultTheme';
import {
  generateColorsNewUI,
  Theme,
} from '@savgroup-front-common/core/theme/Theme';
import { $InitialLoaderContainer } from '@/view/app/App.styles';

import { useGetClientInformation } from './hooks';
import useBridgedSellerTheme from './hooks/useBridgedSellerTheme';
import useSellerTheme from './hooks/useSellerTheme';

export default function ThemeContainer({
  children,
}: React.PropsWithChildren<unknown>) {
  const { clientInformation, isLoading: isClientInformationLoading } =
    useGetClientInformation();

  const { theme, isLoading } = useSellerTheme({
    sellerId: clientInformation?.sellerId || clientInformation?.tenantId,
  });

  const bridgedTheme = useBridgedSellerTheme({ theme });

  const newUI = generateColorsNewUI(bridgedTheme);

  const themeCustom = {
    ...bridgedTheme,
    newUI: {
      ...(bridgedTheme?.newUI ?? {}),
      defaultColors: newUI?.defaultColors,
      variationColors: {
        ...(bridgedTheme?.newUI?.variationColors ?? {}),
        light3: bridgedTheme && bridgedTheme.colors?.default,
      },
      inputBorderColors: {
        ...(bridgedTheme?.newUI?.inputBorderColors ?? {}),
        default: bridgedTheme?.colors?.default,
      },
    },
    flexboxgrid: {
      gutterWidth: 2,
      outerMargin: 0,
    },
    components: {
      ...(bridgedTheme?.components ?? {}),
      defaultLabel: {
        ...(theme?.components?.defaultLabel ?? {}),
        fontSize: '14px',
        fontWeight: '600',
        color:
          bridgedTheme?.colors?.paragraphTextColor ??
          defaultTheme.colors.paragraphTextColor,
        lineHeight: '16px',
      },
    },
  };

  if (isClientInformationLoading || isLoading) {
    return (
      <$InitialLoaderContainer>
        <DefaultLoader color={defaultTheme.colors.mainTextColor} size="50px" />
      </$InitialLoaderContainer>
    );
  }

  return <ThemeProvider theme={Theme(themeCustom)}>{children}</ThemeProvider>;
}
